var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.76161 18.4961C7.03567 18.8067 7.50961 18.8363 7.82021 18.5622C8.1308 18.2882 8.16043 17.8142 7.88637 17.5037L6.16246 15.5499H12.5004C12.9146 15.5499 13.2504 15.2141 13.2504 14.7999C13.2504 14.3857 12.9146 14.0499 12.5004 14.0499H6.16246L7.88637 12.0961C8.16043 11.7855 8.1308 11.3116 7.82021 11.0375C7.50961 10.7634 7.03567 10.7931 6.76161 11.1037L3.93811 14.3037C3.68795 14.5872 3.68795 15.0126 3.93811 15.2961L6.76161 18.4961ZM17.2392 12.8962C16.9652 13.2068 16.4912 13.2364 16.1806 12.9624C15.87 12.6883 15.8404 12.2144 16.1145 11.9038L17.8384 9.95002H11.5004C11.0862 9.95002 10.7504 9.61423 10.7504 9.20002C10.7504 8.78581 11.0862 8.45002 11.5004 8.45002H17.8384L16.1145 6.49624C15.8404 6.18565 15.87 5.7117 16.1806 5.43765C16.4912 5.1636 16.9652 5.19322 17.2392 5.50381L20.0627 8.70381C20.3129 8.98732 20.3129 9.41272 20.0627 9.69624L17.2392 12.8962Z",
    fill: "#B6B8D5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnSwap);
export default __webpack_public_path__ + "static/media/icn-swap.e89f8780333aae1e8337f814011ad302.svg";
export { ForwardRef as ReactComponent };